/**
 * Geração de nomes fofos para Himotchis.
 * Combina: vogal inicial + consoante doce + vogal + sufixo cute.
 */

const STARTERS = [
  'Mi', 'Ma', 'Mo', 'Mu',
  'Ti', 'To', 'Tu', 'Ta',
  'Ki', 'Ka', 'Ko',
  'Pi', 'Po', 'Pu',
  'Ni', 'No', 'Nu',
  'Lo', 'Lu', 'Le',
  'Bi', 'Bu', 'Bo',
  'Cha', 'Chi',
  'Fu', 'Fo',
  'Yu', 'Yo',
  'Suzu', 'Hana',
  'Goro', 'Tama', 'Mocha',
];

const ENDINGS = [
  'mi', 'mo', 'pi', 'po',
  'chi', 'cho',
  'ko', 'ki',
  'lu', 'li',
  'na', 'ni', 'nu',
  'ru', 'ro',
  'tan', 'pyo', 'pin',
  'bee', 'boo',
  'kun', 'chan',
];

export function generateCuteName(rng: () => number = Math.random): string {
  const start = STARTERS[Math.floor(rng() * STARTERS.length)]!;
  const end = ENDINGS[Math.floor(rng() * ENDINGS.length)]!;
  // Evita repetição feia tipo "Mimi-mi"
  return `${start}${end}`;
}
